"use client";

import { LottieWrapper } from "@/components/ui/lottie-wrapper";

import * as animationData from "../../public/animations/loadingAnimation.json";

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: animationData,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

export default function Loading() {
  return (
    <div className="w-full h-screen flex items-center justify-center">
      <LottieWrapper options={defaultOptions} width={100} height={100} />
    </div>
  );
}
